
<template>
  <div>
      <b-container>
        <b-row class="mt-4">
          <b-col>
            <div class="bg-calc">
              <div class="bg-color-calc d-flex align-items-center justify-content-center">
                <b-row class="d-flex align-items-center m-5">
                  <b-col sm="12" class="text-center">
                    <h2 class="text-center p-5 text-white my-header-text">
                      {{ $t('headertitle') }}
                    </h2>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.bg-calc{
  width : 100%;
  height: 250px;
  background-image: url('/img/calc.jpg');
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.bg-color-calc{
  background-color: rgba(94, 114, 228, 0.8) !important;
  height: 250px;
}
</style>